import { useEffect, useRef } from "react";
import { useBlocker } from "react-router-dom";

export const useUnsavedChanges = (
  hasUnsavedChanges: boolean,
  message: string
) => {
  const hasUnsavedChangesRef = useRef(hasUnsavedChanges);

  useEffect(() => {
    hasUnsavedChangesRef.current = hasUnsavedChanges;
  }, [hasUnsavedChanges]);

  useBlocker(() => {
    if (hasUnsavedChangesRef.current) {
      const confirmLeave = window.confirm(message);
      return !confirmLeave;
    }
    return false;
  });

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChangesRef.current) {
        e.preventDefault();
      }
    };

    if (hasUnsavedChanges) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges, message]);

  return () => {
    hasUnsavedChangesRef.current = false;
  };
};
